"use client";

import { useEffect, useState } from "react";

/** Mounts its children only from 768 px, never on the server or a phone, so a hidden video is not even fetched there. */
export default function DesktopOnly({
  children,
}: {
  children: React.ReactNode;
}) {
  const [wide, setWide] = useState(false);
  useEffect(() => {
    const query = window.matchMedia("(min-width: 768px)");
    const update = () => setWide(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return wide ? <>{children}</> : null;
}
